import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=4bef0024&"
import script from "./Documentos.vue?vue&type=script&lang=js&"
export * from "./Documentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports